<form (keydown.enter)="$event.preventDefault()" [formGroup]="formGroup"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="content-container">
    <div class="content">
      <p>The Orbitax Demo gives you a temporary work space where you are free to explore the available solutions and to
        test file imports and features in a standalone test environment.</p>
      <p>The demo will run for 2 hours or until you choose to exit (via the user drop-down in the top right corner), at
        which point you will be returned to your regular company and projects.</p>
      <p><strong>To begin, just type a few words on why you are using this demo.
        We will use this information to assist you should you need any help.</strong></p>
    </div>
    <img
      src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/modal-demo.png"
      alt="demo-image">
  </div>

  <div class="m-t-20 flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Select Demo</mat-label>
      <mat-select formControlName="demo">
        <mat-option attr.data-cy="{{demo.title}}" *ngFor="let demo of (demos$ | async)" [value]="demo">
          {{demo.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" style="margin-bottom: 0;flex-grow:1">
      <mat-label>Comment</mat-label>
      <textarea matInput type="text" [(ngModel)]="comment" formControlName="comment"
                placeholder="Enter comment..." rows="5">

      </textarea>
    </mat-form-field>
  </div>
</form>
